var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "users-sell-out" },
    [
      _c("div", { staticClass: "totals" }, [
        _c("span", [
          _vm._v(
            "\n      Total de SDZ consolidado: " +
              _vm._s(
                _vm.totalSeedz !== null
                  ? `${_vm.$currencyFormat(_vm.totalSeedz)} SDZ`
                  : "Processando..."
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.isComercial && _vm.isPBI66613FlagActive
          ? _c("span", { staticClass: "ml-3" }, [
              _vm._v(
                "\n      Total de SDZ com aceleradores: " +
                  _vm._s(
                    _vm.totalAcceleratorSeedz !== null
                      ? `${_vm.$currencyFormat(_vm.totalAcceleratorSeedz)} SDZ`
                      : "Processando..."
                  ) +
                  "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showParticipantsProportion
          ? _c("span", { staticClass: "ml-3" }, [
              _vm._v(
                "\n      Porcentagem equipe: " +
                  _vm._s(_vm.participantsProportion) +
                  "%\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showSellerProportion
          ? _c("span", { staticClass: "ml-3" }, [
              _vm._v(
                "\n      Porcentagem vendedor: " +
                  _vm._s(_vm.apportionment.ownerProportion) +
                  "%\n    "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm.apportionmentType
          ? _c("span", [
              _vm._v(
                _vm._s(
                  _vm.apportionmentType === "seller"
                    ? "Vendedor"
                    : _vm.participantTitle
                )
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "AppInfiniteScroll",
        {
          ref: "infiniteScroll",
          attrs: {
            loading: _vm.loading,
            "last-items": _vm.isLastPage,
            "max-height": "400px",
          },
          on: { nextPage: _vm.nextPage },
        },
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headersParticipants,
              items: _vm.participants,
              expand: false,
              "item-key": "_id",
              "max-height": "250px",
              "hide-actions": "",
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function (participant) {
                  return [
                    _c(
                      "tr",
                      {
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.showProducts(participant)
                          },
                        },
                      },
                      [
                        _c("td", [_vm._v(_vm._s(participant.item.name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(participant.item.role))]),
                        _vm._v(" "),
                        _vm.showTotalAcceleratorSDZ && _vm.isComercial
                          ? _c("td", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    participant.item.totalAcceleratorSeedz
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(participant.item.totalSeedz))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { width: "40px" } },
                          [
                            _c(
                              "v-icon",
                              { staticStyle: { cursor: "pointer" } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      participant.expanded
                                        ? "expand_less"
                                        : "expand_more"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "expand",
                fn: function (participant) {
                  return [
                    participant.item.products &&
                    participant.item.products.length
                      ? _c("ParticipantsProducts", {
                          attrs: {
                            products: participant.item.products,
                            role: _vm.role,
                            loading: participant.item.loadingProducts,
                            hasTotalAcceleratorSDZ: _vm.showTotalAcceleratorSDZ,
                          },
                        })
                      : _c(
                          "div",
                          { staticClass: "product-details" },
                          [
                            participant.item.loadingProducts
                              ? _c("AppLoadingIcon", {
                                  attrs: { color: "#CCCCCC" },
                                })
                              : _c("span", [
                                  _vm._v("Nenhum resultado encontrado"),
                                ]),
                          ],
                          1
                        ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }